import { DynamicFooter } from 'components/Footer/DynamicFooter';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import ShareIcon from '@material-ui/icons/Share';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import {
	CalcType,
	CommonStatus,
	CreditCardType,
	OrderDiscountStatus,
	OrderItemDiscountStatus,
	OrderStatus,
	PatronClass,
	PaymentClass,
	PaymentStatus,
	ReceiptConnectType,
	useCloseTableStatusMutation,
	useCreateReceiptAttachmentMutation,
	useEmailSendMutation,
	useGetBillQuery,
	useGetCnBillOrderItemLazyQuery,
	useGetDiscountQuery,
	useGetHomeTableSummaryQuery,
	useGetMenuXDebtorListLazyQuery,
	useGetMenuXInhouseListLazyQuery,
	useGetOfficerLazyQuery,
	useGetOfficerQuery,
	useGetOrderQuery,
	useGetReceiptPrinterLazyQuery,
	useGetRoundingPolicyQuery,
	useGetStaffLazyQuery,
	useGetStaffQuery,
	useGetTaxSchemeDetailLazyQuery,
	useGetTaxSchemeDetailQuery,
	useGetTaxSummaryQuery,
	useGetUsersByAccountAndSoftwareQuery,
} from 'generated/graphql';
import { sortDescByKey } from 'helpers/hooks/stringNumberFunction/sortByKey';
import * as htmlToImage from 'html-to-image';
import React, {
	Reducer,
	useContext,
	useEffect,
	useReducer,
	useRef,
	useState,
} from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import ShareDialog, {
	EmailDialog,
	PhoneNumDialog,
} from '../../../../../../components/Dialog/ShareDialog';
import '../../../../BusinessInsights/BusinessAnalytics/bi.scss';
import '../billSettlement.scss';
import {
	BillReceiptDisplay,
	isBlankSignatureImage,
	PrinterDialog,
	printReceipt,
	printReceiptText,
} from './BillReceiptFunctions';
import { Overlay } from '@ifca-root/react-component/src/components/Overlay/Overlay';
import RefreshButton from 'components/Button/RefreshButton';
import { BuyerDetailsForm } from './BuyerDetailsForm';
import { useSnackBar } from 'helpers/hooks/useSnackBar';
import SnackBarMsg from '@ifca-root/react-component/src/components/SnackBar/SnackBarMsg';
import ReactDOMServer from 'react-dom/server';
import { amtStr } from 'helpers/numFormatter';
import { formatDate } from 'helpers/hooks/formatDate';
import { colors } from '@material-ui/core';
import { IAction } from 'helpers/model';
import { useForm } from 'react-hook-form';
import { CloseTableDialog } from 'containers/OutletModule/HomeNew/CloseTable/CloseTableDialog';
import { generateRoundingAmount } from 'containers/OutletModule/HomeNew/SharedFunction';
import { OutletIcon } from 'assets';
import { printBillReceiptUSBPOS } from '../../POSPrinter/BillReceipt/posBillReceiptPrinterUSB';
import { printBillReceiptRawViaLocalAgent } from 'services/localPrintAgentReceipt';
const dateFormat = require('dateformat');

// import PhoneIcon from '@mui/icons-material/Phone';

export interface PaymentItemProps {
	key?: typeof String;
}

export interface TokenOption {
	discount: Number;
	subtotal: Number;
	serviceCharge: Number;
	tax: Number;
	total: Number;
}

interface OrderItemTax {
	taxAmount: number;
	taxSchemeType: string;
}

interface OrderItemOptionItemTax {
	taxAmount: number;
}

interface OrderItemDiscountTax {
	taxAmount: number;
}

interface OrderItemOptionItemDiscountTax {
	taxAmount: number;
}

interface OrderDiscountItemTax {
	taxAmount: number;
}
interface orderDiscountItemOptionTax {
	taxAmount: number;
}

interface OrderDiscountItem {
	orderItemID?: string;
	baseAmount: number;
	orderDiscountItemTax?: OrderDiscountItemTax[];
}

interface OrderItemDiscount {
	orderItemID?: string;
	baseAmount: number;
	status: string;
	orderItemDiscountTax: OrderItemDiscountTax[];
}
interface OrderItemOptionItem {
	optionItemID: string;
	price: number;
	basePrice: number;
	unitPrice: number;
	orderItemOptionItemTax: OrderItemOptionItemTax[];
	discountBaseAmount: number;
	orderItemOptionItemDiscountTax: OrderItemOptionItemDiscountTax[];
	orderDiscountItemOptionTax: orderDiscountItemOptionTax[];
	// Include other properties if needed
}

interface OrderItemOption {
	optionID: string;
	orderItemOptionItem: OrderItemOptionItem[];
	// Include other properties if needed
}
interface Item {
	ID: string;
	amount: number;
	orderItemTax: OrderItemTax[];
	orderItemDiscount?: OrderItemDiscount;
	orderDiscountItem?: OrderDiscountItem;
	orderItemOption?: OrderItemOption[];
}

interface Props {
	closeTableDialog: boolean;
	tableID: string;
	outletID: string;
}

interface CloseTableProps {
	tableID?: String;
	status?: OrderStatus;
}

export const BillReceipt = (props: any) => {
	useEffect(() => {
		console.log('BillReceipt Outlet App');
	}, []);

	const user = JSON.parse(localStorage.getItem('loggedInUser'));
	const { module, mode } = props;
	const history = useHistory();
	const { pathname } = useLocation();
	const { [`tableID`]: tableID, outletID, orderID, billID } = useParams<
		Record<string, any>
	>();

	const initialState: Props = {
		closeTableDialog: false,
		tableID: tableID,
		outletID: outletID,
	};

	const reducer: Reducer<Props, IAction> = (state, action) => {
		switch (action.type) {
			case 'reset':
				return initialState;
			default:
				return { ...state, [action.type]: action.payload };
		}
	};

	const [state, dispatch] = useReducer(reducer, initialState);

	const { snackFunc, snackBarMessage, openSnackBar } = useSnackBar();

	const { handleSubmit } = useForm<CloseTableProps>({
		defaultValues: {},
	});

	const [hotelGuest, setHotelGuest] = useState({} as any);
	const [nonGuest, setNonGuest] = useState({} as any);
	const [hotelDebtor, setHotelDebtor] = useState({} as any);
	const [officer, setOfficer] = useState({} as any);
	const [staff, setStaff] = useState({} as any);
	const [latestPayment, setLatestPayment] = useState([] as any);
	const [outlet, setOutlet] = useState({} as any);
	const [chargeInfo1, setChargeInfo1] = useState('' as any);
	const [chargeInfo2, setChargeInfo2] = useState('' as any);

	const [openPhoneNum, setOpenPhoneNum] = useState(false);
	const [openEmail, setOpenEmail] = useState(false);

	const [fs, setFS] = useState(null);
	const [sc, setSC] = useState(null);
	const [ta, setTa] = useState(null);
	const [fd, setFD] = useState(null);
	const [to, setTo] = useState(null);
	const [ra, setRA] = useState(null);
	const [optDisc, setOptDisc] = useState(null);

	const creditClass = creditClass => {
		let credClass;

		if (creditClass === CreditCardType.AmericanExpressCard) {
			credClass = 'American Express Card';
		} else if (creditClass === CreditCardType.DinersCard) {
			credClass = 'Diners Card';
		} else if (creditClass === CreditCardType.JcbCard) {
			credClass = 'JCB Card';
		} else if (creditClass === CreditCardType.Mastercard) {
			credClass = 'Master Card';
		} else if (creditClass === CreditCardType.UnionpayCard) {
			credClass = 'UNION PAY';
		} else if (creditClass === CreditCardType.VisaCard) {
			credClass = 'Visa Card';
		} else if (creditClass === CreditCardType.DebitCard) {
			credClass = 'Debit Card';
		} else if (creditClass === CreditCardType.Ewallet) {
			credClass = 'E-Wallet';
		}
		return credClass;
	};

	useEffect(() => {
		let info1;

		latestPayment?.map(x => {
			info1 = creditClass(x?.creditCardType);
			if (x?.paymentClass === PaymentClass.Credit) {
				return (
					setChargeInfo1(info1), setChargeInfo2(`****${x?.cardNo?.slice(-4)}`)
				);
			} else if (x?.paymentClass === PaymentClass.Room) {
				return (
					// setChargeInfo1(hotelGuest?.RoomNo),
					setChargeInfo1(x?.hotelGuestInfo?.RoomNo),
					setChargeInfo2(x?.hotelGuestInfo?.FullName)
				);
			} else if (x?.paymentClass === PaymentClass.NonGuest) {
				return (
					setChargeInfo1(null), setChargeInfo2(x?.hotelGuestInfo?.FullName)
				);
			} else if (x?.paymentClass === PaymentClass.SuspendFolio) {
				return (
					setChargeInfo1(null), setChargeInfo2(x?.hotelGuestInfo?.FullName)
				);
			} else if (x?.paymentClass === PaymentClass.Debtor) {
				return (
					setChargeInfo1(x?.hotelGuestInfo?.GuestType),
					setChargeInfo2(x?.hotelGuestInfo?.FullName)
				);
			} else if (x?.paymentClass === PaymentClass.Staff) {
				return (
					setChargeInfo1(staff[0]?.designation), setChargeInfo2(staff[0]?.name)
				);
			} else if (x?.paymentClass === PaymentClass.Officer) {
				return (
					setChargeInfo1(officer[0]?.designation),
					setChargeInfo2(officer[0]?.name)
				);
			} else if (x?.paymentClass === PaymentClass.BankTt) {
				return setChargeInfo1(null), setChargeInfo2(x?.remark);
			}

			return {
				...x,
				chargeInfo1: chargeInfo1,
				chargeInfo2: chargeInfo2,
			};
		});
	});

	const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
		SnackBarContext as any,
	);

	const [negOrderItem, setNegOrderItem] = useState({});
	const [receiptDataURL, setReceiptDataURL] = useState(null);
	const [baseImage, setBaseImage] = useState(null);
	const [signImage, setSignImage] = useState(null);
	const signatureLoadRef = useRef(0);
	const [qrEInvoiceImage, setQREInvoiceImage] = useState(null);
	const [outletImage, setOutletImage] = useState(null);
	const [isBixolon, setIsBixolon] = useState(null);

	const handleSort = arr => {
		let temp = arr?.slice();
		return sortDescByKey(temp, 'createdTs');
	};

	const [isCash, setIsCash] = useState(false);

	useEffect(() => {
		const cash = latestPayment?.filter(
			x => x?.paymentClass === PaymentClass?.Cash,
		);

		if (cash) {
			setIsCash(true);
		}
	}, [latestPayment]);

	const {
		refetch,
		loading: billLoading,
		called: billCalled,
		data: { getBill } = { getBill: [] },
	} = useGetBillQuery({
		fetchPolicy: 'network-only',
		variables: { ID: billID },
		onCompleted: ({ getBill }) => {
			const latestPayment = handleSort(
				getBill[0]?.payments?.filter(x => x?.status === 'OPEN'),
			);

			const outlet = getBill[0]?.outlet;

			//LOGO

			// OLD BASE64
			/*
			var xhr = new XMLHttpRequest();
			xhr.open('GET', `${getBill[0]?.outlet?.logo?.fileURL}`);
			xhr.responseType = 'blob';
			xhr.send();

			var reader = new FileReader();
			xhr.addEventListener('load', function() {
				reader.readAsDataURL(xhr.response);
				reader.addEventListener('loadend', function() {
					setBaseImage(reader.result);
				});
			});
			*/

			// NEW BASE64
			const getBase64FromUrlForOutletLogo = async url => {
				// const data = await fetch(url, { method: 'GET', mode: 'cors', cache: 'no-cache', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', }, });
				const data = await fetch(url);
				const blob = await data.blob();
				return new Promise(resolve => {
					const reader = new FileReader();
					reader.readAsDataURL(blob);
					reader.onloadend = () => {
						const base64data = reader.result;
						resolve(base64data);
						setBaseImage(reader.result);
					};
				});
			};
			getBase64FromUrlForOutletLogo(
				`${getBill[0]?.outlet?.logo?.fileURL ?? OutletIcon}`,
			);

			// BASE64 FOR QR EINVOICE PRINT RECEIPT USED ONLY
			const getBase64FromUrlForQREinvoiceWithPadding = async (
				url: string,
				padding: number = 200,
				targetSize: number = 196,
			): Promise<string> => {
				// Fetch the image data from the URL
				const data = await fetch(url);
				const blob = await data.blob();

				return new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.readAsDataURL(blob);
					reader.onloadend = () => {
						const base64Image = reader.result as string;

						// Once the image is loaded, process it to add padding and resize
						addUniformPaddingAndShrinkImage(base64Image, padding, targetSize)
							.then(resizedImageBase64 => {
								resolve(resizedImageBase64); // Return the final base64 image
							})
							.catch(error => {
								reject(
									`Error processing the image with padding and resizing: ${error}`,
								);
							});
					};
				});
			};

			// BASE64 FOR OUTLET LOGO PRINT RECEIPT USED ONLY
			const getBase64FromUrlForOutletLogoWithPadding = async (
				url: string,
				padding: number = 200,
				targetSize: number = 196,
			): Promise<string> => {
				// Fetch the image data from the URL
				const data = await fetch(url);
				const blob = await data.blob();

				return new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.readAsDataURL(blob);
					reader.onloadend = () => {
						const base64Image = reader.result as string;

						// Once the image is loaded, process it to add padding and resize
						addUniformPaddingAndShrinkImage(base64Image, padding, targetSize)
							.then(resizedImageBase64 => {
								resolve(resizedImageBase64); // Return the final base64 image
							})
							.catch(error => {
								reject(
									`Error processing the image with padding and resizing: ${error}`,
								);
							});
					};
				});
			};

			// Function to add padding and resize the image (as previously defined)
			function addUniformPaddingAndShrinkImage(
				base64Image: string,
				padding: number = 200,
				targetSize: number = 196,
			): Promise<string> {
				return new Promise((resolve, reject) => {
					const img = new Image();
					img.onload = () => {
						const canvas = document.createElement('canvas');
						const ctx = canvas.getContext('2d');

						if (!ctx) {
							reject('Failed to get canvas context.');
							return;
						}

						// Calculate new canvas dimensions with padding
						const canvasWidth = img.width + 2 * padding;
						const canvasHeight = img.height + 2 * padding;
						canvas.width = canvasWidth;
						canvas.height = canvasHeight;

						// Set the background color to white
						ctx.fillStyle = 'white';
						ctx.fillRect(0, 0, canvasWidth, canvasHeight);

						// Draw the image with padding
						ctx.drawImage(img, padding, padding);

						// Create a new canvas for resizing the image
						const resizedCanvas = document.createElement('canvas');
						const resizedCtx = resizedCanvas.getContext('2d');

						if (!resizedCtx) {
							reject('Failed to get resized canvas context.');
							return;
						}

						// Resize the canvas to the target size (196x196)
						resizedCanvas.width = targetSize;
						resizedCanvas.height = targetSize;

						// Draw the image (with padding) onto the resized canvas
						resizedCtx.drawImage(
							canvas,
							0,
							0,
							canvasWidth,
							canvasHeight,
							0,
							0,
							targetSize,
							targetSize,
						);

						// Convert the resized image to base64 format
						const newBase64Image = resizedCanvas.toDataURL('image/png');
						resolve(newBase64Image); // Return the final base64 image
					};

					img.onerror = () => reject('Error loading image');
					img.src = base64Image;
				});
			}

			// Example Usage:
			getBase64FromUrlForQREinvoiceWithPadding(
				`${getBill[0]?.qrCodeUrl}`,
				150,
				250,
			)
				.then(resizedImageBase64 => {
					console.log('Resized base64 image with padding:', resizedImageBase64);
					setQREInvoiceImage(resizedImageBase64); // Use the resized base64 image as needed
				})
				.catch(error => {
					console.error('Error fetching and processing the image:', error);
				});

			// Example Usage:
			getBase64FromUrlForOutletLogoWithPadding(
				`${getBill[0]?.outlet?.logo?.fileURL ?? OutletIcon}`,
				400,
				196,
			)
				.then(resizedImageBase64 => {
					console.log('Resized base64 image with padding:', resizedImageBase64);
					setOutletImage(resizedImageBase64); // Use the resized base64 image as needed
				})
				.catch(error => {
					console.error('Error fetching and processing the image:', error);
				});

			const getBase64FromUrlForSign = async (url: string) => {
				const data = await fetch(url);
				const blob = await data.blob();
				// Skip non-image responses (e.g. HTML error page when the URL is invalid)
				if (!blob?.type?.startsWith('image')) {
					return null;
				}

				const base64data = await new Promise<string | null>(resolve => {
					const reader = new FileReader();
					reader.readAsDataURL(blob);
					reader.onloadend = () => {
						resolve((reader.result as string) || null);
					};
					reader.onerror = () => resolve(null);
				});

				if (!base64data) {
					return null;
				}

				const isBlank = await isBlankSignatureImage(base64data);
				return isBlank ? null : base64data;
			};

			// Only fetch the signature when the bill actually has one
			const signatureFileURL = getBill[0]?.signature?.fileURL;
			const signatureLoadId = ++signatureLoadRef.current;

			if (
				typeof signatureFileURL === 'string' &&
				signatureFileURL.trim().length > 0
			) {
				getBase64FromUrlForSign(signatureFileURL).then(base64data => {
					if (signatureLoadRef.current !== signatureLoadId) {
						return;
					}

					setSignImage(base64data);
				});
			} else {
				setSignImage(null);
			}
			// NEW BASE64

			setLatestPayment(latestPayment);
			setOutlet(outlet);
			let temp = {};
			getBill[0]?.orderItem?.map(el => {
				let totalTax = 0;
				el?.orderItemTax?.map(x => {
					totalTax += x?.taxAmount;
				});

				const activeOID = el?.orderItemDiscount?.filter(
					i => i?.status === OrderItemDiscountStatus?.Active,
				)[0];

				let totalOIDTax = 0;
				activeOID?.orderItemDiscountTax?.map(v => {
					totalOIDTax += v?.taxAmount;
				});

				let totalODITax = 0;
				el?.orderDiscountItem?.orderDiscountItemTax?.map(v => {
					totalODITax += v?.taxAmount;
				});

				if (el?.refID && el?.quantity < 0) {
					if (el?.refID in temp) {
						temp[el?.refID].quantity += el?.quantity * -1;
						temp[el?.refID].amount += el?.amount * -1;
						temp[el?.refID].taxAmount += totalTax * -1;

						temp[el?.refID].orderItemDiscBaseAmount += activeOID?.baseAmount;
						temp[el?.refID].orderItemDiscTaxAmount += totalOIDTax;

						temp[el?.refID].orderDiscountItemBaseAmount +=
							el?.orderDiscountItem?.baseAmount;
						temp[el?.refID].orderDiscountItemTaxAmount += totalODITax;
					} else {
						temp[el?.refID] = {
							quantity: el?.quantity * -1,
							amount: el?.amount * -1,
							taxAmount: totalTax * -1,

							orderItemDiscBaseAmount:
								isNaN(activeOID?.baseAmount * -1) === true
									? 0
									: activeOID?.baseAmount * -1,
							orderItemDiscTaxAmount:
								isNaN(totalOIDTax * -1) === true ? 0 : totalOIDTax * -1,

							orderDiscountItemBaseAmount:
								isNaN(el?.orderDiscountItem?.baseAmount * -1) === true
									? 0
									: el?.orderDiscountItem?.baseAmount * -1,
							orderDiscountItemTaxAmount:
								isNaN(totalODITax * -1) === true ? 0 : totalODITax * -1,

							orderItemOptions: [],
						};
						// Loop through the orderItemOptionArray
						for (let i = 0; i < el?.orderItemOption?.length; i++) {
							const option = el?.orderItemOption[i];
							const optionItem = el?.orderItemOption[i]?.orderItemOptionItem;

							let optionData;

							if (optionItem) {
								optionItem?.map(x => {
									let totalTax = 0;
									x?.orderItemOptionItemTax?.map(v => {
										totalTax += v?.taxAmount;
									});

									let totalOptItemOIDTax = 0;
									x?.orderItemOptionItemDiscountTax?.map(v => {
										totalOptItemOIDTax += v?.taxAmount;
									});

									let totalOptItemODITax = 0;
									x?.orderDiscountItemOptionTax?.map(v => {
										totalOptItemODITax += v?.taxAmount;
									});

									optionData = {
										optionID: option?.optionID,
										orderItemOptionItem: {
											basePrice: x?.basePrice * -1,
											taxAmount: totalTax * -1,
											discountBaseAmount: x?.discountBaseAmount * -1,
											itemDiscountTaxAmount: totalOptItemOIDTax * -1,
											discountItemTaxAmount: totalOptItemODITax * -1,
										},
									};
								});
								temp[el?.refID].orderItemOptions.push(optionData);
							}
						}
					}
				}
			});
			setNegOrderItem({ ...temp });
			if (getBill[0]?.documentType === 'CN') {
				loadCNBillOrderItem({
					variables: {
						outletID: outletID,
						ogBillID: getBill[0]?.refID,
					},
				});
			}

			latestPayment?.map(x => {
				if (
					outlet?.outletChannel?.hotelID &&
					x?.registrationID &&
					x?.paymentClass === PaymentClass.Debtor
				) {
					loadMenuXDebtor({
						variables: {
							hotelID: outlet?.outletChannel?.hotelID,
							outletID: outletID,
						},
					});
				} else if (
					outlet?.outletChannel?.hotelID &&
					x?.registrationID &&
					(x?.paymentClass === PaymentClass.Room ||
						x?.paymentClass === PaymentClass.NonGuest ||
						x?.paymentClass === PaymentClass.SuspendFolio)
				) {
					loadMenuXInhouse({
						variables: {
							hotelID: outlet?.outletChannel?.hotelID,
							outletID: outletID,
						},
					});
				} else if (x?.paymentClass === PaymentClass.Officer) {
					loadOfficer({
						variables: { ID: x?.patronAccountID },
					});
				} else if (x?.paymentClass === PaymentClass.Staff) {
					loadStaff({
						variables: { ID: x?.patronAccountID },
					});
				}
				// else if (x?.paymentClass === PaymentClass.Cash) {
				// 	loadOfficer({
				// 		variables: { ID: getBill[0]?.order?.patronAccountID },
				// 	});
				// 	loadStaff({
				// 		variables: { ID: getBill[0]?.order?.patronAccountID },
				// 	});
				// } else {
				// 	loadOfficer({
				// 		variables: { ID: getBill[0]?.order?.patronAccountID },
				// 	});
				// 	loadStaff({
				// 		variables: { ID: getBill[0]?.order?.patronAccountID },
				// 	});
				// }
			});
			loadReceiptPrinter({
				variables: {
					outletID: outletID,
					isDefault: true,
				},
			});
		},
	});

	const [
		loadCNBillOrderItem,
		{
			loading: cnBillOrderItemLoading,
			error: cnBillOrdwerItemError,
			data: { getCNBillOrderItem } = { getCNBillOrderItem: [] },
		},
	] = useGetCnBillOrderItemLazyQuery({
		fetchPolicy: 'no-cache',
		variables: {
			outletID: outletID,
			ogBillID: getBill[0]?.refID,
		},
		onCompleted: ({ getCNBillOrderItem }) => {
			let temp = {};
			getCNBillOrderItem?.map(el => {
				let totalTax = 0;
				el?.orderItemTax?.map(x => {
					totalTax += x?.taxAmount;
				});

				const activeOID = el?.orderItemDiscount?.filter(
					i => i?.status === OrderItemDiscountStatus?.Active,
				)[0];

				let totalOIDTax = 0;
				activeOID?.orderItemDiscountTax?.map(v => {
					totalOIDTax += v?.taxAmount;
				});

				let totalODITax = 0;
				el?.orderDiscountItem?.orderDiscountItemTax?.map(v => {
					totalODITax += v?.taxAmount;
				});

				if (el?.refID && el?.quantity < 0) {
					if (el?.refID in temp) {
						temp[el?.refID].quantity += el?.quantity * -1;
						temp[el?.refID].amount += el?.amount;
						temp[el?.refID].taxAmount += totalTax;

						temp[el?.refID].orderItemDiscBaseAmount += activeOID?.baseAmount;
						temp[el?.refID].orderItemDiscTaxAmount += totalOIDTax;

						temp[el?.refID].orderDiscountItemBaseAmount +=
							el?.orderDiscountItem?.baseAmount;
						temp[el?.refID].orderDiscountItemTaxAmount += totalODITax;
					} else {
						temp[el?.refID] = {
							quantity: el?.quantity * -1,
							amount: el?.amount * -1,
							taxAmount: totalTax * -1,

							orderItemDiscBaseAmount:
								isNaN(activeOID?.baseAmount * -1) === true
									? 0
									: activeOID?.baseAmount * -1,
							orderItemDiscTaxAmount:
								isNaN(totalOIDTax * -1) === true ? 0 : totalOIDTax * -1,

							orderDiscountItemBaseAmount:
								isNaN(el?.orderDiscountItem?.baseAmount * -1) === true
									? 0
									: el?.orderDiscountItem?.baseAmount * -1,
							orderDiscountItemTaxAmount:
								isNaN(totalODITax * -1) === true ? 0 : totalODITax * -1,

							orderItemOptions: [],
						};
						// Loop through the orderItemOptionArray
						for (let i = 0; i < el?.orderItemOption?.length; i++) {
							const option = el?.orderItemOption[i];
							const optionItem = el?.orderItemOption[i]?.orderItemOptionItem;

							let optionData;

							if (optionItem) {
								optionItem?.map(x => {
									let totalTax = 0;
									x?.orderItemOptionItemTax?.map(v => {
										totalTax += v?.taxAmount;
									});

									let totalOptItemOIDTax = 0;
									x?.orderItemOptionItemDiscountTax?.map(v => {
										totalOptItemOIDTax += v?.taxAmount;
									});

									let totalOptItemODITax = 0;
									x?.orderDiscountItemOptionTax?.map(v => {
										totalOptItemODITax += v?.taxAmount;
									});

									optionData = {
										optionID: option?.optionID,
										orderItemOptionItem: {
											basePrice: x?.basePrice * -1,
											taxAmount: totalTax * -1,
											discountBaseAmount: x?.discountBaseAmount * -1,
											itemDiscountTaxAmount: totalOptItemOIDTax * -1,
											discountItemTaxAmount: totalOptItemODITax * -1,
										},
									};
								});
								temp[el?.refID].orderItemOptions.push(optionData);
							}
						}
					}
				}
			});
			setNegOrderItem({ ...temp });
		},
	});

	const oiArray =
		getBill[0]?.documentType === 'BILL'
			? getBill[0]?.orderItem
			: getCNBillOrderItem;

	const [
		loadMenuXInhouse,
		{
			loading: MenuXInhouseListLoading,
			called: MenuXInhouseListCalled,
			data: { getMenuXInhouseList } = { getMenuXInhouseList: [] },
		},
	] = useGetMenuXInhouseListLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: ({ getMenuXInhouseList }) => {
			if (latestPayment?.paymentClass === PaymentClass.Room) {
				setHotelGuest(
					getMenuXInhouseList?.data?.MenuXInhouseList?.filter(
						guest => guest?.RegistrationID === latestPayment?.registrationID,
					)[0],
				);
			} else if (latestPayment?.paymentClass === PaymentClass.NonGuest) {
				setNonGuest(
					getMenuXInhouseList?.data?.MenuXInhouseList?.filter(
						guest => guest?.RegistrationID === latestPayment?.registrationID,
					)[0],
				);
			}
		},
	});

	const [
		loadMenuXDebtor,
		{
			loading: MenuXDebtorListLoading,
			called: MenuXDebtorListCalled,
			data: { getMenuXDebtorList } = { getMenuXDebtorList: [] },
		},
	] = useGetMenuXDebtorListLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: ({ getMenuXDebtorList }) => {
			setHotelDebtor(
				getMenuXDebtorList?.data?.MenuXDebtorList?.filter(
					guest => guest?.RegistrationID === latestPayment?.registrationID,
				)[0],
			);
		},
	});

	const {
		loading: userLoading,
		error,
		data: { getUsersByAccountAndSoftware } = {
			getUsersByAccountAndSoftware: [],
		},
	} = useGetUsersByAccountAndSoftwareQuery({
		fetchPolicy: 'network-only',
		variables: {
			status: CommonStatus.Active,
		},
	});

	const {
		loading: getTaxSummaryLoading,
		data: { getTaxSummary } = { getTaxSummary: [] },
	} = useGetTaxSummaryQuery({
		skip:
			!outletID ||
			!getBill[0]?.order?.ID ||
			!user?.accountID,
		fetchPolicy: 'network-only',
		variables: {
			outletID: outletID as string,
			orderID: getBill[0]?.order?.ID as string,
			accountID: user?.accountID as string,
		},
	});

	const {
		loading: homeTableSummaryLoading,
		data: homeTableSummaryData,
	} = useGetHomeTableSummaryQuery({
		fetchPolicy: 'network-only',
		variables: {
			tableID: tableID,
		},
	});

	const closeAmount = homeTableSummaryData?.close?.closeAmount;

	console.log('getTaxSummary 1 >>>', getTaxSummary);

	const [
		loadReceiptPrinter,
		{
			loading: receiptPrinterLoading,
			called: receiptPrinterCalled,
			data: { getReceiptPrinter } = { getReceiptPrinter: [] },
		},
	] = useGetReceiptPrinterLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: async ({ getReceiptPrinter }) => {
			if (
				getReceiptPrinter[0]?.isSDK === true &&
				isBixolon === true &&
				(mode === 'bill-printing' ||
					mode === 'void-payment' ||
					mode === 'void-bill' ||
					mode === 'digital-document')
			) {
				printReceiptText(
					baseImage,
					outlet,
					getBill[0],
					mode,
					orderItems,
					negOrderItem,
					{
						discount: fd,
						subtotal: fs,
						serviceCharge: sc,
						tax: ta,
						total: to,
						rounding: ra,
					},
					getDiscount,
					latestPayment,
					chargeInfo1,
					chargeInfo2,
					outlet?.currencyCode ?? '',
					optDisc,
					patronName,
					// signImage,
					getReceiptPrinter[0]?.name,
					module,
					isCash,
					'bill-receipt',
					getTaxSchemeDetail,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					getUsersByAccountAndSoftware,
					officer,
					staff,
					getTaxSummary,
				);

				setIsBixolon(false);
			}

			if (
				getReceiptPrinter[0]?.isSDK === true &&
				isBixolon === true &&
				(mode === 'dineIn' || mode === 'takeAway')
			) {
				const copies = Math.max(1, Number(getReceiptPrinter?.[0]?.copies) || 1);
						console.log('getreceiptPrinter',getReceiptPrinter?.[0]?.copies,copies);
						
				if (getReceiptPrinter?.length > 0) {
					for (let i = 0; i < copies; i++) {
						console.log(`Printing USB receipt copy ${i + 1} of ${copies}`);
						printReceiptText(
							baseImage,
							outlet,
							getBill[0],
							mode,
							orderItems,
							negOrderItem,
							{
								discount: fd,
								subtotal: fs,
								serviceCharge: sc,
								tax: ta,
								total: to,
								rounding: ra,
							},
							getDiscount,
							latestPayment,
							chargeInfo1,
							chargeInfo2,
							outlet?.currencyCode ?? '',
							optDisc,
							patronName,
							// signImage,
							getReceiptPrinter[0]?.name,
							module,
							isCash,
							'bill-receipt',
							getTaxSchemeDetail,
							null,
							null,
							null,
							null,
							null,
							null,
							null,
							null,
							null,
							null,
							null,
							null,
							null,
							null,
							getUsersByAccountAndSoftware,
							officer,
							staff,
							getTaxSummary,
						);
					}
					// printReceiptText(
					// 	baseImage,
					// 	outlet,
					// 	getBill[0],
					// 	mode,
					// 	orderItems,
					// 	negOrderItem,
					// 	{
					// 		discount: fd,
					// 		subtotal: fs,
					// 		serviceCharge: sc,
					// 		tax: ta,
					// 		total: to,
					// 		rounding: ra,
					// 	},
					// 	getDiscount,
					// 	latestPayment,
					// 	chargeInfo1,
					// 	chargeInfo2,
					// 	outlet?.currencyCode ?? '',
					// 	optDisc,
					// 	patronName,
					// 	// signImage,
					// 	getReceiptPrinter[0]?.name,
					// 	module,
					// 	isCash,
					// 	'bill-receipt',
					// 	getTaxSchemeDetail,
					// 	null,
					// 	null,
					// 	null,
					// 	null,
					// 	null,
					// 	null,
					// 	null,
					// 	null,
					// 	null,
					// 	null,
					// 	null,
					// 	null,
					// 	null,
					// 	null,
					// 	getUsersByAccountAndSoftware,
					// 	officer,
					// 	staff,
					// 	getTaxSummary,
					// );
					setIsBixolon(false);
				} else if (getReceiptPrinter?.length === 0) {
					localPrinter();
				}
			}

			/* By Default: 
			Receipt printer should only be printed at the main terminal
			 - Receipt printer cvan be set up through the db under ReceiptPrinter
			*/
		},
	});

	const [
		loadOfficer,
		{
			loading: getOfficerLoading,
			called: getOfficerCalled,
			data: { getOfficer } = { getOfficer: {} as any },
		},
	] = useGetOfficerLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: ({ getOfficer }) => {
			setOfficer(getOfficer);
			setPatronName(getOfficer[0]?.name);
		},
	});

	const [
		loadStaff,
		{
			loading: getStaffLoading,
			called: getStaffCalled,
			data: { getStaff } = { getStaff: {} as any },
		},
	] = useGetStaffLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: ({ getStaff }) => {
			setStaff(getStaff);
			setPatronName(getStaff[0]?.name);
		},
	});

	const {
		loading: getDiscountLoading,
		called: getDiscountCalled,
		data: { getDiscount } = { getDiscount: [] },
	} = useGetDiscountQuery({
		fetchPolicy: 'network-only',
		variables: {
			outletID: outletID,
		},
	});

	const patronClass = getBill[0]?.order?.patron?.patronClass;
	const patronAccountID = getBill[0]?.order?.patronAccountID;

	const [patronName, setPatronName] = useState('');

	useEffect(() => {
		if (patronClass === 'Officer') {
			loadOfficer({
				variables: { ID: getBill[0]?.order?.patronAccountID },
			});

			// const officer = getOfficer?.filter(x => x?.ID === patronAccountID)[0]
			// 	?.name;
			setPatronName(officer[0]?.name);
		} else if (patronClass === 'Staff') {
			loadStaff({
				variables: { ID: getBill[0]?.order?.patronAccountID },
			});
			// const staff = getStaff?.filter(x => x?.ID === patronAccountID)[0]?.name;
			setPatronName(staff[0]?.name);
		} else if (patronClass === 'Hotel Guest' || patronClass === 'Visitor') {
			setPatronName(getBill[0]?.order?.patronName || `-`);
		}
	}, [patronClass]);

	const phoneNumber =
		patronClass === 'Visitor'
			? getBill[0]?.order?.contactNo
			: patronClass === 'Officer'
			? officer[0]?.mobileNo
			: patronClass === 'Staff'
			? staff[0]?.mobileNo
			: patronClass === 'Hotel Guest'
			? getMenuXInhouseList?.data?.MenuXInhouseList?.filter(
					guest => guest?.RegistrationID === patronAccountID,
			  )[0]?.ContactNo
			: undefined;

	const orderItems = oiArray
		?.map(el => {
			if (
				el?.quantity - negOrderItem?.[el?.ID]?.quantity === 0 ||
				el?.quantity < 0
			) {
				return { ...el, void: true };
			} else {
				return { ...el, void: false };
			}
		})
		?.filter(list => list.void === false);

	const fixOrderItems = oiArray;

	const [openShareDialog, setOpenShareDialog] = useState(false);
	const [openSendEmail, setOpenSendEmail] = useState(false);
	const [email, setEmail] = useState(getBill[0]?.order?.email);

	const [
		EmailSend,
		{
			data: { emailSend } = { emailSend: {} as any },
			loading: loadingEmailSend,
		},
	] = useEmailSendMutation({});

	function generateUniqueCID() {
		const uniqueId = Date.now().toString(); // Use a timestamp as part of the identifier
		const randomPart = Math.random()
			.toString(36)
			.substring(2, 8); // Add a random part
		return `image-${uniqueId}-${randomPart}`;
	}

	const ContentShare = () => (
		<div
			className="content-container"
			style={{
				position: 'fixed',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
			}}
		>
			<a target="_blank" rel="noopener noreferrer">
				<img
					src={createReceiptAttachment?.fileURL}
					alt="Displayed Image"
					width="500px"
					height="500px"
				/>
			</a>
		</div>
	);

	const body = `Dear Customer,

I hope this email finds you well.

Please find the attached invoice for the transaction. The details of the invoice are as follows:

Invoice Number: ${getBill[0]?.billNo}
Date: ${dateFormat(new Date(), 'dd-mmm-yyyy')}
Amount: RM ${amtStr(to)}
`;

	useEffect(() => {
		const QRContentString = ReactDOMServer.renderToStaticMarkup(ContentShare());

		openSendEmail &&
			EmailSend({
				variables: {
					body: {
						Header: `${outlet?.name} has shared you a receipt - ${getBill[0]?.billNo}`,
						Body: body,
					},
					outletID: outletID,
					email: getBill[0]?.order?.email || email,
					attachments: {
						filename: `${getBill[0]?.billNo}.jpg`,
						path: createReceiptAttachment?.fileURL,
						cid: QRContentString,
					},
				},
			}).then(x => {
				if (x?.data?.emailSend === true) {
					snackFunc('Sent Email Successfully!', false);
					setOpenShareDialog(false);
				} else {
					snackFunc('Sent Email Fail!', false);
				}
			});
	}, [openSendEmail]);

	const [
		createAttachment,
		{
			data: { createReceiptAttachment } = {
				createReceiptAttachment: {} as any,
			},
			called: createReceiptAttachmentCalled,
			loading: createReceiptAttachmentLoading,
		},
	] = useCreateReceiptAttachmentMutation({
		// onCompleted: () => {
		// 	setOpenShareDialog(true);
		// },
	});

	const [
		closeTableStatus,
		{ data: createOrder, loading: closeTableLoading },
	] = useCloseTableStatusMutation({
		onError: error => {
			console.log('Suberror', error);
			setOpenSnackBar(true);
			setSnackBarMsg('Failed to close table');
		},
		onCompleted: data => {
			setOpenSnackBar(true);
			setSnackBarMsg('Closed table successfully');
			history.push({
				pathname: `/menu/outlet-app/${outletID}/table/grid`,
				state: { success: true, msgMode: 'create' },
			});
		},
	});

	const onSubmit = blob => {
		createAttachment({
			variables: {
				file: blob,
				billID: billID,
				outletID: outletID,
			},
		});
	};

	const onCloseSubmit = async (data: any) => {
		closeTableStatus({
			variables: {
				tableID: tableID,
				billInput: [],
			},
		});
	};

	const shareReceiptRef = useRef(null);

	useEffect(() => {
		if (openShareDialog) {
			const timeoutId = setTimeout(() => {
				if (shareReceiptRef.current) {
					const attachment = shareReceiptRef.current;

					htmlToImage
						.toBlob(attachment, {
							style: { background: '#ffffff' },
							cacheBust: true,
						})
						.then(value => {
							onSubmit(value);
						})
						.catch(error => {
							console.error('Error generating image blob:', error);
						});
				} else {
					console.error('Element with id "share-receipt" not found.');
				}
			}, 100); // Delay execution to allow for rendering

			return () => clearTimeout(timeoutId); // Cleanup timeout on unmount
		}
	}, [openShareDialog]);

	const {
		data: { getRoundingPolicy } = { getRoundingPolicy: [] },
		loading: getRoundingPolicyLoading,
	} = useGetRoundingPolicyQuery({
		fetchPolicy: 'network-only',
		variables: { accountID: user?.accountID },
	});

	//CALCULATION

	let ttl,
		subtotal,
		finalServiceCharge,
		finalTax,
		total,
		discount,
		totalOptItm,
		discOptItm,
		optTaxAmount,
		discOptTaxAmount,
		discOptServiceCharge,
		totalOptItmPerOrderItemAll,
		orderDiscount,
		roundingAmount;
	if (orderItems?.length > 0) {
		const itemArray = oiArray;

		//convert and fetch important data

		const filterItemArray: {
			ID: string;
			amount: number;
			orderItemTax: OrderItemTax[];
			orderItemDiscount?: OrderItemDiscount;
			orderDiscountItem?: OrderDiscountItem;
			orderItemOption?: OrderItemOption[];
		}[] = itemArray.map(
			({
				ID,
				amount,
				orderItemTax,
				orderItemDiscount,
				orderDiscountItem,
				orderItemOption,
			}) => {
				const activeOID = orderItemDiscount?.filter(
					x => x?.status === OrderItemDiscountStatus.Active,
				)[0];

				return {
					ID,
					amount,
					orderItemTax: orderItemTax?.map(({ taxAmount, taxSchemeType }) => ({
						taxAmount,
						taxSchemeType,
					})),
					orderItemDiscount: {
						baseAmount: activeOID?.baseAmount ?? 0,
						status: activeOID?.status ?? '',
						orderItemID: ID,
						orderItemDiscountTax: activeOID
							? activeOID?.orderItemDiscountTax?.map(({ taxAmount }) => ({
									taxAmount,
							  }))
							: [{ taxAmount: 0 }],
					},
					orderDiscountItem: {
						baseAmount: orderDiscountItem?.baseAmount ?? 0,
						orderItemID: ID,
						orderDiscountItemTax: orderDiscountItem?.orderDiscountItemTax
							? orderDiscountItem?.orderDiscountItemTax?.map(
									({ taxAmount }) => ({
										taxAmount,
									}),
							  )
							: [{ taxAmount: 0 }],
					},
					orderItemOption: orderItemOption?.map(
						({ optionID, orderItemOptionItem }) => ({
							optionID,
							orderItemOptionItem: orderItemOptionItem.map(
								({
									optionItemID,
									price,
									basePrice,
									unitPrice,
									orderItemOptionItemTax,
									discountBaseAmount,
									orderItemOptionItemDiscountTax,
									orderDiscountItemOptionTax,
								}) => ({
									optionItemID,
									price,
									basePrice,
									unitPrice,
									orderItemOptionItemTax: orderItemOptionItemTax?.map(
										({ taxAmount }) => ({
											taxAmount,
										}),
									),
									discountBaseAmount,
									orderItemOptionItemDiscountTax: orderItemOptionItemDiscountTax?.map(
										({ taxAmount }) => ({
											taxAmount,
										}),
									),
									orderDiscountItemOptionTax: orderDiscountItemOptionTax?.map(
										({ taxAmount }) => ({
											taxAmount,
										}),
									),
									// Include other properties if needed
								}),
							),
							// Include other properties from OrderItemOption if needed
						}),
					),
				};
			},
		);

		//subtotal amount
		const sumAmount = (items: Item[]): number => {
			let totalBaseAmount = 0;
			for (const item of items) {
				totalBaseAmount += item.amount;
			}
			return totalBaseAmount;
		};

		const totalAmount = sumAmount(filterItemArray);

		//subtotal tax amount

		const sumTaxAmount = (items: Item[]): number => {
			let totalTax = 0;
			for (const item of items) {
				for (const tax of item?.orderItemTax) {
					totalTax += tax?.taxAmount;
				}
			}
			return totalTax;
		};

		const totalTaxAmount = sumTaxAmount(filterItemArray);
		const roundedTotalTaxAmount = parseFloat(totalTaxAmount.toFixed(2));

		//subtotal order discount item base amount

		const sumODIBaseAmount = (items: Item[]): number => {
			let totalODIBaseAmt = 0;
			for (const item of items) {
				totalODIBaseAmt += item?.orderDiscountItem?.baseAmount;
			}
			return totalODIBaseAmt;
		};

		const totalODIBaseAmount = sumODIBaseAmount(filterItemArray);

		//subtotal order discount item tax amount

		const sumODITaxAmount = (items: Item[]): number => {
			let totalTax = 0;
			for (const item of items) {
				for (const tax of item?.orderDiscountItem?.orderDiscountItemTax)
					totalTax += tax?.taxAmount;
			}
			return totalTax;
		};

		const totalODITaxAmount = sumODITaxAmount(filterItemArray);
		const roundedTotalODITaxAmount = parseFloat(totalODITaxAmount.toFixed(2));

		//subtotal order item discount base amount
		const sumOIDBaseAmount = (items: Item[]): number => {
			let totalOIDBaseAmt = 0;
			for (const item of items) {
				totalOIDBaseAmt += item?.orderItemDiscount?.baseAmount;
			}
			return totalOIDBaseAmt;
		};

		const totalOIDBaseAmount = sumOIDBaseAmount(filterItemArray);

		//subtotal order item discount tax amount

		const sumOIDTaxAmount = (items: Item[]): number => {
			let totalOIDTax = 0;
			for (const item of items) {
				for (const tax of item?.orderItemDiscount?.orderItemDiscountTax) {
					totalOIDTax += tax?.taxAmount;
				}
			}
			return totalOIDTax;
		};

		const totalOIDTaxAmount = sumOIDTaxAmount(filterItemArray);
		const roundedTotalOIDTaxAmount = parseFloat(totalOIDTaxAmount.toFixed(2));

		//overall option item important field to sum up
		const sumOptionItemOverallField = (
			items: Item[],
		): {
			basePrice: number;
			taxAmount: number;
			discountBaseAmount: number;
			itemDiscountTaxAmount: number;
			discountItemTaxAmount: number;
		} => {
			let totalBasePriceOpt = 0;
			let totalTaxAmountOpt = 0;
			let totalDiscBaseAmountOpt = 0;
			let totalItemDiscTaxAmountOpt = 0;
			let totalDiscItemTaxAmountOpt = 0;
			for (const item of items) {
				if (item.orderItemOption) {
					for (const option of item.orderItemOption) {
						if (option.orderItemOptionItem) {
							for (const optionItem of option.orderItemOptionItem) {
								let totalTax = 0;
								optionItem?.orderItemOptionItemTax?.map(x => {
									totalTax += x?.taxAmount;
								});

								let totalOptItemOIDTax = 0;
								optionItem?.orderItemOptionItemDiscountTax?.map(x => {
									totalOptItemOIDTax += x?.taxAmount;
								});

								let totalOptItemODITax = 0;
								optionItem?.orderDiscountItemOptionTax?.map(v => {
									totalOptItemODITax += v?.taxAmount;
								});

								totalBasePriceOpt += optionItem.basePrice;
								totalTaxAmountOpt += totalTax;
								totalDiscBaseAmountOpt += optionItem.discountBaseAmount;
								totalItemDiscTaxAmountOpt += totalOptItemOIDTax;
								totalDiscItemTaxAmountOpt += totalOptItemODITax;
							}
						}
					}
				}
			}
			return {
				basePrice: totalBasePriceOpt,
				taxAmount: parseFloat(totalTaxAmountOpt.toFixed(2)),
				discountBaseAmount: totalDiscBaseAmountOpt,
				itemDiscountTaxAmount: parseFloat(totalItemDiscTaxAmountOpt.toFixed(2)),
				discountItemTaxAmount: parseFloat(totalDiscItemTaxAmountOpt.toFixed(2)),
			};
		};

		const sumOptionItemPerOrderItem = (
			items: Item[],
		): {
			orderItemID: string;
			basePrice: number;
			taxAmount: number;
			discountBaseAmount: number;
			itemDiscountTaxAmount: number;
			discountItemTaxAmount: number;
		}[] => {
			const resultArray = [];

			items?.forEach(x => {
				let totalBasePriceOpt = 0;
				let totalTaxAmountOpt = 0;
				let totalDiscBaseAmountOpt = 0;
				let totalItemDiscTaxAmountOpt = 0;
				let totalDiscItemTaxAmountOpt = 0;
				let orderitemIDOpts = x?.ID;

				if (x.orderItemOption) {
					for (const option of x.orderItemOption) {
						if (option.orderItemOptionItem) {
							for (const optionItem of option.orderItemOptionItem) {
								let totalTax = 0;
								optionItem?.orderItemOptionItemTax?.map(x => {
									totalTax += x?.taxAmount;
								});

								let totalOptItemOIDTax = 0;
								optionItem?.orderItemOptionItemDiscountTax?.map(x => {
									totalOptItemOIDTax += x?.taxAmount;
								});

								let totalOptItemODITax = 0;
								optionItem?.orderDiscountItemOptionTax?.map(v => {
									totalOptItemODITax += v?.taxAmount;
								});

								totalBasePriceOpt += optionItem.basePrice;
								totalTaxAmountOpt += totalTax;
								totalDiscBaseAmountOpt += optionItem.discountBaseAmount;
								totalItemDiscTaxAmountOpt += totalOptItemOIDTax;
								totalDiscItemTaxAmountOpt += totalOptItemODITax;
							}
						}
					}
				}

				resultArray.push({
					orderItemID: orderitemIDOpts,
					basePrice: totalBasePriceOpt,
					taxAmount: parseFloat(totalTaxAmountOpt.toFixed(2)),
					discountBaseAmount: totalDiscBaseAmountOpt,
					itemDiscountTaxAmount: parseFloat(
						totalItemDiscTaxAmountOpt.toFixed(2),
					),
					discountItemTaxAmount: parseFloat(
						totalDiscItemTaxAmountOpt.toFixed(2),
					),
				});
			});

			return resultArray;
		};

		totalOptItmPerOrderItemAll = sumOptionItemPerOrderItem(filterItemArray);

		const totalOptItmOverallAmount = sumOptionItemOverallField(filterItemArray);

		optTaxAmount = totalOptItmOverallAmount?.taxAmount;

		discOptTaxAmount =
			totalOptItmOverallAmount?.itemDiscountTaxAmount +
			totalOptItmOverallAmount?.discountItemTaxAmount;

		totalOptItm =
			totalOptItmOverallAmount?.basePrice + totalOptItmOverallAmount?.taxAmount;

		discOptItm =
			totalOptItmOverallAmount?.discountBaseAmount +
			totalOptItmOverallAmount?.itemDiscountTaxAmount +
			totalOptItmOverallAmount?.discountItemTaxAmount;

		//tax
		finalTax =
			roundedTotalTaxAmount +
			optTaxAmount -
			roundedTotalODITaxAmount -
			roundedTotalOIDTaxAmount -
			discOptTaxAmount;

		//subtotal
		subtotal = totalAmount + roundedTotalTaxAmount + totalOptItm;

		//discount
		let ODI = totalODIBaseAmount + roundedTotalODITaxAmount;

		let OID = totalOIDBaseAmount + roundedTotalOIDTaxAmount;

		discount = ODI + OID + discOptItm;

		//total
		total = subtotal - discount;

		roundingAmount =
			getRoundingPolicy[0]?.inUse === true
				? generateRoundingAmount(
						total,
						getRoundingPolicy[0]?.smallestDenomination,
						getRoundingPolicy,
				  )
				: 0;
	}
	useEffect(() => {
		setFS(subtotal);
		setSC(finalServiceCharge);
		setTa(finalTax);
		setFD(discount);
		setTo(total);
		setRA(roundingAmount);
		setOptDisc(totalOptItmPerOrderItemAll);
	}, [
		subtotal,
		finalServiceCharge,
		finalTax,
		discount,
		total,
		// totalOptItmPerOrderItemAll,
	]);

	const [orderPatron, setOrderPatron] = useState(null);

	const filterOrder = data => {
		return data?.filter(
			v => v?.orderItem?.filter(e => e?.billID === null).length > 0,
		);
	};

	//Printer
	const {
		data: { getTaxSchemeDetail } = {
			getTaxSchemeDetail: null,
		},
		loading: getTaxSchemeDetailLoading,
	} = useGetTaxSchemeDetailQuery({
		skip:
			!user?.accountID ||
			!outlet?.taxSchemeID ||
			!getBill[0]?.order?.ID,
		fetchPolicy: 'no-cache',
		variables: {
			accountID: user?.accountID as string,
			taxSchemeID: outlet?.taxSchemeID as string,
			orderID: getBill[0]?.order?.ID as string,
		},
	});

	const [openPrinterDialog, setOpenPrinterDialog] = useState(false);
	const [printer, setPrinter] = useState(false);

	const handlePrinting = () => {
		if (getReceiptPrinter[0]?.isSDK === true) {
			setIsBixolon(true);
			loadReceiptPrinter({
				variables: {
					outletID,
					isDefault: true,
				},
			});
		} else {
			sendReceiptToPrinter();
		}
	};

	const bixolonPrinter = () => {
		setIsBixolon(true);
		handlePrinting();
	};

	const localPrinter = () => {
		setOpenPrinterDialog(false);
		let temp = document.getElementById('share-receipt');
		htmlToImage
			.toPng(temp, {
				style: { background: '#ffffff' },
				cacheBust: true,
			})
			.then(x => {
				const win = window.open('', '');
				win.document.write('<html><head>');
				win.document.write('</head><body >');
				win.document.write('<img id="print-image-element" src="' + x + '"/>');
				win.document.write(
					'<script>var img = document.getElementById("print-image-element"); img.addEventListener("load",function(){ window.focus(); window.print(); window.document.close(); window.close(); }); </script>',
				);
				win.document.write('</body></html>');
				win.document?.close();
				setTimeout(() => {
					win.window.print();
				}, 100);
			})
			.catch(error => {
				console.error('Printing failed', error);
			});
	};

	const Einvoice =
		getBill[0]?.einvoice_qr_url === null && getBill[0]?.is_einvoice === true;

	const EinvoiceCheck =
		outlet?.company?.isEInvIntegrated === true &&
		new Date(getBill[0]?.businessDate) <=
			new Date(outlet?.company?.eInvStartDate) &&
		new Date(getBill[0]?.businessDate) >= new Date(outlet?.company?.eInvEndDate)
			? getBill[0]?.einvoice_qr_url === null && getBill[0]?.is_einvoice === true
			: false;
	const isEInvoice = getBill[0]?.is_einvoice === true ? true : false;
	const isEInvIntegrated =
		getBill[0]?.outlet?.company?.isEInvIntegrated === true ? true : false;
	const isIntegrate3rdPartyeInvoice =
		getBill[0]?.outlet?.integrate3rdPartyeInvoice === true ? true : false;

	const [isBuyerDetails, setIsBuyerDetails] = useState(false);

	const [connectedPrinter, setConnectedPrinter] = useState<any | null>(null);
	const [loading, setLoading] = useState(false);
	const [sendPrint, setSendPrint] = useState(false);

	// Retrieve the printer data from localStorage
	useEffect(() => {
		const storedPrinter = getReceiptPrinter[0]?.deviceInfo;
		const isSDK = getReceiptPrinter[0]?.isSDK;

		if (
			mode === 'bill-printing' &&
			storedPrinter !== null &&
			isSDK === false &&
			openPrinterDialog === true
		) {
			connectToPrinter(storedPrinter);
		} else if (mode === 'dineIn' && storedPrinter !== null && isSDK === false) {
			connectToPrinter(storedPrinter);
		} else if (openPrinterDialog === false && sendPrint === false) {
			disconnectFromPrinter();
		} else if (state.closeTableDialog === false || isBuyerDetails === false) {
			connectToPrinter(storedPrinter);
		}

		// if (storedPrinter !== null && isSDK === false) {
		// 	connectToPrinter(storedPrinter);
		// }
	}, [
		getReceiptPrinter[0]?.ID,
		openPrinterDialog,
		sendPrint,
		state,
		isBuyerDetails,
	]);

	const connectToPrinter = async (printerData: any) => {
		try {
			setLoading(true);

			// Get the list of devices that match the vendorId and productId
			const devices = await navigator.usb.getDevices();
			const matchedDevice = devices.find(
				device =>
					device.vendorId === printerData.vendorId &&
					device.productId === printerData.productId,
			);

			if (matchedDevice) {
				console.log('Printer found:', matchedDevice);

				// Open the device and select configuration
				await matchedDevice.open();
				await matchedDevice.selectConfiguration(1);
				console.log('Configuration selected:', matchedDevice.configuration);

				if (
					!matchedDevice.configuration ||
					!matchedDevice.configuration.interfaces
				) {
					throw new Error('No interfaces found for this configuration');
				}

				const interfaces = matchedDevice.configuration.interfaces;
				console.log('Interfaces:', interfaces);

				// Claim the first interface
				await matchedDevice.claimInterface(0);
				console.log('Interface claimed');

				// Store the device object for later use
				setConnectedPrinter(matchedDevice);
				console.log('Printer connected successfully!');
			} else {
				console.error('Printer not found in the list of connected devices');
				console.error('No matching printer found');
			}
		} catch (err) {
			console.error('Error connecting to the printer:', err.message);
			console.error('Failed to connect to the printer');
		} finally {
			setLoading(false);
		}
	};

	const disconnectFromPrinter = async () => {
		if (!connectedPrinter) {
			console.warn('No printer is currently connected.');
			return;
		}

		try {
			setLoading(true);

			// Release the claimed interface (assuming 0 was claimed)
			await connectedPrinter.releaseInterface(0);
			console.log('Interface released');

			// Close the device
			await connectedPrinter.close();
			console.log('Printer disconnected successfully');

			// Clear the stored printer reference
			setConnectedPrinter(null);
		} catch (err) {
			console.error('Error disconnecting from the printer:', err.message);
		} finally {
			setLoading(false);
		}
	};

	const sendReceiptToPrinter = async () => {
		console.log('Testing Testing Testing');
		
	const copies =
		mode === 'bill-settlement' ||
		mode === 'dineIn' ||
		mode === 'takeAway'
			? Math.max(1, Number(getReceiptPrinter?.[0]?.copies) || 1)
			: 1;
		console.log('getreceiptPrinter',getReceiptPrinter?.[0]?.copies,copies,"Current mode:", mode);
		if (getReceiptPrinter[0]?.connectType === ReceiptConnectType.Usb) {
			if (!connectedPrinter) {
				console.error('No printer connected. Please connect a printer first.');
				return;
			}

			console.log('Printer connected, starting receipt print process...');
			setSendPrint(true);
			setLoading(true);

			try {
				console.log('Calling printReceipt...');
				for (let i = 0; i < copies; i++) {
					console.log(`Printing USB receipt copy ${i + 1} of ${copies}`);
				await printBillReceiptUSBPOS(
					connectedPrinter,
					outletImage,
					qrEInvoiceImage,
					outlet,
					getBill[0],
					mode,
					orderItems,
					negOrderItem,
					{
						discount: fd,
						subtotal: fs,
						serviceCharge: sc,
						tax: ta,
						total: to,
					},
					getDiscount,
					latestPayment,
					chargeInfo1,
					chargeInfo2,
					outlet?.currencyCode ?? '',
					optDisc,
					patronName,
					getReceiptPrinter[0]?.name,
					module,
					isCash,
					'bill-receipt',
					getTaxSchemeDetail,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					getUsersByAccountAndSoftware,
					officer,
					staff,
					getTaxSummary,
					getReceiptPrinter[0]?.deviceAlignmentCode,
				);
				}
				// await printBillReceiptUSBPOS(
				// 	connectedPrinter,
				// 	outletImage,
				// 	qrEInvoiceImage,
				// 	outlet,
				// 	getBill[0],
				// 	mode,
				// 	orderItems,
				// 	negOrderItem,
				// 	{
				// 		discount: fd,
				// 		subtotal: fs,
				// 		serviceCharge: sc,
				// 		tax: ta,
				// 		total: to,
				// 	},
				// 	getDiscount,
				// 	latestPayment,
				// 	chargeInfo1,
				// 	chargeInfo2,
				// 	outlet?.currencyCode ?? '',
				// 	optDisc,
				// 	patronName,
				// 	getReceiptPrinter[0]?.name,
				// 	module,
				// 	isCash,
				// 	'bill-receipt',
				// 	getTaxSchemeDetail,
				// 	null,
				// 	null,
				// 	null,
				// 	null,
				// 	null,
				// 	null,
				// 	null,
				// 	null,
				// 	null,
				// 	null,
				// 	null,
				// 	null,
				// 	null,
				// 	null,
				// 	getUsersByAccountAndSoftware,
				// 	officer,
				// 	staff,
				// 	getTaxSummary,
				// 	getReceiptPrinter[0]?.deviceAlignmentCode,
				// );
				console.log('Receipt printed and paper cut successfully!');
				console.log(
					'%cReceipt printed successfully!',
					'color: #12850b;',
					JSON.stringify(
						{
							productName: JSON.parse(localStorage.getItem('connectedPrinter'))
								?.productName,
							productId: JSON.parse(localStorage.getItem('connectedPrinter'))
								?.productId,
							vendorId: JSON.parse(localStorage.getItem('connectedPrinter'))
								?.vendorId,
						},
						null,
						'\t',
					),
				);
			} catch (error) {
				console.error('Failed to send data to the printer:', error);
				alert('Failed to print receipt!');
			} finally {
				// disconnectFromPrinter();
				setSendPrint(false);
				setLoading(false);
			}
		} else if (
			getReceiptPrinter[0]?.connectType === ReceiptConnectType.Network
		) {
			console?.log('Printing via Network Printer');
			// Network printer: try Local Print Agent for bill-receipt (same format as printReceiptText/BillReceipt)
			if (
				getReceiptPrinter?.length > 0 &&
				(mode === 'bill-printing' ||
					mode === 'void-payment' ||
					mode === 'void-bill' ||
					mode === 'digital-document' ||
					mode === 'bill-settlement' ||
					mode === 'dineIn' ||
					mode === 'takeAway')
			) {
				try {
					for (let i = 0; i < copies; i++) {
						console.log();
						
						console.log(`Printing Nwtwork receipt copy ${i + 1} of ${copies}`);
						await printBillReceiptRawViaLocalAgent({
							outlet,
							outletName: outlet?.name,
							mode,
							bill: getBill[0],
							orderItems,
							negOrderItem,
							getDiscount,
							totals: {
								discount: Number(fd),
								subtotal: Number(fs),
								serviceCharge: Number(sc),
								tax: Number(ta),
								total: Number(to),
								rounding: Number(ra),
							},
							latestPayment,
							getTaxSchemeDetail,
							getTaxSummary,
							getUsersByAccountAndSoftware,
							officer,
							staff,
							currencyCode: outlet?.currencyCode ?? '',
							patronName: patronName ?? '',
							logoUrl: outlet?.logo?.fileURL,
							printerName: getReceiptPrinter[0]?.deviceIP,
							width: getReceiptPrinter[0]?.deviceAlignmentCode,
						});
					}
					// await printBillReceiptRawViaLocalAgent({
					// 	outlet,
					// 	outletName: outlet?.name,
					// 	mode,
					// 	bill: getBill[0],
					// 	orderItems,
					// 	negOrderItem,
					// 	getDiscount,
					// 	totals: {
					// 		discount: Number(fd),
					// 		subtotal: Number(fs),
					// 		serviceCharge: Number(sc),
					// 		tax: Number(ta),
					// 		total: Number(to),
					// 		rounding: Number(ra),
					// 	},
					// 	latestPayment,
					// 	getTaxSchemeDetail,
					// 	getTaxSummary,
					// 	getUsersByAccountAndSoftware,
					// 	officer,
					// 	staff,
					// 	currencyCode: outlet?.currencyCode ?? '',
					// 	patronName: patronName ?? '',
					// 	logoUrl: outlet?.logo?.fileURL,
					// 	printerName: getReceiptPrinter[0]?.deviceIP,
					// 	width: getReceiptPrinter[0]?.deviceAlignmentCode,
					// });
				} catch (e) {
					console.warn(
						'Local Print Agent (bill-receipt):',
						(e as Error)?.message ?? e,
					);
				}
			}
		}
	};

	console?.log(state, openPrinterDialog, mode, 'mode apa');

	console.log('outlet',outlet?.isRetail);
	
	return (
		<>
			{billLoading && <Loading />}
			{createReceiptAttachmentLoading && <Loading />}
			{getStaffLoading && <Loading />}
			{getOfficerLoading && <Loading />}
			{MenuXDebtorListLoading && <Loading />}
			{MenuXInhouseListLoading && <Loading />}
			{getDiscountLoading && <Loading />}
			{receiptPrinterLoading && <Loading />}
			{cnBillOrderItemLoading && <Loading />}
			{loadingEmailSend && <Loading />}

			<div className={'example-screoutleten'}>
				<MainHeader
					onClick={() => {
						history.goBack();
					}}
					mainBtn="back"
					smTitle="Outlet App"
					title={outlet?.name}
					routeSegments={[
						{ name: 'Table Layout' },
						{ name: 'Table 03 (HARDCODE)' },
						{ name: 'Bill', current: true },
						{ name: 'Receipt', current: true },
					]}
				/>
			</div>

			<div id="share-receipt" ref={shareReceiptRef}>
				{isBuyerDetails === false ? (
					<ContentWrapper footer float>
						{!billLoading && !cnBillOrderItemLoading && (
							<>
								{mode == 'void-payment' ? (
									<>
										<BillReceiptDisplay
											outlet={outlet}
											outletLogo={baseImage}
											signImage={signImage}
											data={getBill}
											orderItems={orderItems}
											footerToken={{
												discount: fd,
												subtotal: fs,
												serviceCharge: sc,
												tax: ta,
												total: to,
												rounding: ra,
											}}
											negOrderItem={negOrderItem}
											discount={getDiscount}
											hidden={false}
											mode={'void-payment'}
											hotelGuest={hotelGuest}
											hotelDebtor={hotelDebtor}
											officer={officer}
											staff={staff}
											latestPayment={latestPayment}
											chargeInfo1={chargeInfo1}
											chargeInfo2={chargeInfo2}
											currencyCode={outlet?.currencyCode ?? ''}
											totalOptItmPerOrderItem={optDisc}
											outletID={outletID}
											patronName={patronName}
										/>
									</>
								) : mode == 'void-bill' ? (
									<>
										<BillReceiptDisplay
											outlet={outlet}
											outletLogo={baseImage}
											signImage={signImage}
											data={getBill}
											orderItems={orderItems}
											footerToken={{
												discount: fd,
												subtotal: fs,
												serviceCharge: sc,
												tax: ta,
												total: to,
												rounding: ra,
												// optDisc: optDisc,
											}}
											negOrderItem={negOrderItem}
											discount={getDiscount}
											hidden={false}
											mode={'void-bill'}
											hotelGuest={hotelGuest}
											hotelDebtor={hotelDebtor}
											officer={officer}
											staff={staff}
											latestPayment={latestPayment}
											chargeInfo1={chargeInfo1}
											chargeInfo2={chargeInfo2}
											currencyCode={outlet?.currencyCode ?? ''}
											totalOptItmPerOrderItem={optDisc}
											outletID={outletID}
											patronName={patronName}
										/>
									</>
								) : (
									<>
										<BillReceiptDisplay
											outlet={outlet}
											outletLogo={baseImage}
											signImage={signImage}
											data={getBill}
											orderItems={orderItems}
											footerToken={{
												discount: fd,
												subtotal: fs,
												serviceCharge: sc,
												tax: ta,
												total: to,
												rounding: ra,
												// optDisc: optDisc,
											}}
											negOrderItem={negOrderItem}
											discount={getDiscount}
											hidden={false}
											mode={''}
											hotelGuest={hotelGuest}
											hotelDebtor={hotelDebtor}
											officer={officer}
											staff={staff}
											latestPayment={latestPayment}
											chargeInfo1={chargeInfo1}
											chargeInfo2={chargeInfo2}
											currencyCode={outlet?.currencyCode ?? ''}
											totalOptItmPerOrderItem={optDisc}
											outletID={outletID}
											patronName={patronName}
										/>
									</>
								)}
							</>
						)}
					</ContentWrapper>
				) : (
					<BuyerDetailsForm
						data={getBill[0]}
						isBuyerDetails={isBuyerDetails}
						setIsBuyerDetails={setIsBuyerDetails}
					/>
				)}
			</div>

			{/* {Einvoice ? (
				<RefreshButton onClick={() => refetch()} floatTotalAmt />
			) : null} */}

			{createReceiptAttachmentCalled &&
				!createReceiptAttachmentLoading &&
				ShareDialog({
					shareTitle: `Share Receipt - ${getBill[0]?.order?.docNo}`,
					title: `Share Receipt`,
					URL: createReceiptAttachment?.fileURL,
					setSimple: setOpenShareDialog,
					simple: openShareDialog,
					emailShare: email,
					setSimpleEmail: setOpenSendEmail,
					isReceipt: true,
					phoneNumber: phoneNumber,
					setOpenPhoneNum: setOpenPhoneNum,
					setOpenEmail: setOpenEmail,
				})}

			<PhoneNumDialog
				open={openPhoneNum}
				setOpen={setOpenPhoneNum}
				shareTitle={`Share Receipt - ${getBill[0]?.order?.docNo}`}
				URL={createReceiptAttachment?.fileURL}
			/>

			<EmailDialog
				open={openEmail}
				setOpen={setOpenEmail}
				setSimpleEmail={setOpenSendEmail}
				setEmail={setEmail}
			/>

			<div className={'example-screen'}>
				{isBuyerDetails === false ? (
					<DynamicFooter
						overlap
						isHidden={openShareDialog}
						options={[
							outlet?.isRetail===false?
							{ 
								name: 'Close Table',
								onClick: () => {
									dispatch({ type: 'closeTableDialog', payload: true });
									disconnectFromPrinter();
								},
								display: mode === 'dineIn',
								disabled: closeAmount > 0,
								color: closeAmount > 0 ? 'inherit' : 'primary',
							}:null,
							{
								name: 'Buyer Details',
								onClick: () => {
									setIsBuyerDetails(true);
									disconnectFromPrinter();
								},
								display:
									isEInvoice &&
									isEInvIntegrated &&
									(getBill[0]?.einvoice_status === 'RECORDED' ||
										getBill[0]?.einvoice_status === 'FAILED_VALIDATION')
										? true
										: false,
								color: 'primary',
							},
							{
								name:
									filterOrder(getBill[0]?.order?.orderItem)?.length === 0
										? 'Home'
										: 'Back',
								onClick: () => {
									if (mode === 'takeAway') {
										history.push(`/menu/outlet-app/${outletID}/takeaway`);
									} else {
										module === 'bill-settlement'
											? history.push({
													pathname: outlet?.isRetail === true?`/menu/outlet-app/${outletID}/retail`:`/menu/outlet-app/${outletID}/table/grid`,
											  })
											: history.push({
													pathname: `/menu/outlet-app/${outletID}/bill-listing`,
											  });
									}
									disconnectFromPrinter();
								},

								color: 'primary',
							},
							{
								name: 'Print',
								onClick: () => {
									if (
										mode === 'bill-printing' ||
										mode === 'void-payment' ||
										mode === 'void-bill' ||
										mode === 'digital-document'
									) {
										setOpenPrinterDialog(true);
									} else if (mode === 'dineIn' || mode === 'takeAway') {
										handlePrinting();
									}
								},
								className: 'noPrint',
								color: !EinvoiceCheck ? 'primary' : 'secondary',
								// color: 'primary',
								props: {
									type: 'submit',
								},
								disabled: EinvoiceCheck,
							},
							{
								name: 'Share',
								onClick: () => {
									setOpenShareDialog(true);
								},
								// color: !EinvoiceCheck ? 'primary' : 'secondary',
								color: 'primary',
								props: {
									type: 'submit',
								},
								// disabled: EinvoiceCheck,
								startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
							},
						].filter(Boolean)}
					/>
				) : null}
			</div>

			<PrinterDialog
				openPrinterDialog={openPrinterDialog}
				setOpenPrinterDialog={setOpenPrinterDialog}
				printer={printer}
				setPrinter={setPrinter}
				bixolonPrinter={
					getReceiptPrinter[0]?.isSDK === true
						? bixolonPrinter
						: sendReceiptToPrinter
				}
				localPrinter={localPrinter}
				isSDK={getReceiptPrinter[0]?.isSDK}
			/>

			<CloseTableDialog
				state={state}
				dispatch={dispatch}
				table={getBill[0]?.order?.table}
				getOrder={[]}
				orderItems={orderItems}
			/>

			<SnackBarMsg open={openSnackBar} message={snackBarMessage} />
		</>
	);
};
